export enum THEME {
  LIGHT = 'light',
  DARK = 'dark'
}